import { createRequestTypes } from '../utils';

export const FETCH_ERROR_LIST = createRequestTypes('errors/FETCH_ERROR_LIST');
